import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ServicesPage from './pages/ServicesPage';
import TeamPage from './pages/TeamPage';
import HomePage from './pages/HomePage';
import NewsPage from './pages/NewsPage';
import ContactPage from './pages/ContactPage';
import Header from './components/Header';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <Header />
      <main className="pt-16 min-h-[calc(100vh-4rem-3rem)]"> 
        {/* 留空間給 header/footer}*/ }
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/news" element={<NewsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          {/* 404頁面 */}
          <Route path="*" element={<div className="text-center mt-20">404 - 頁面不存在</div>} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default App;
